import { useMemo } from 'react';

// // third-party
import useSWR, { mutate } from 'swr';

const initialState = {
  isDashboardDrawerOpened: false,
  isComponentDrawerOpened: true
};

export const endpoints = {
  key: 'api/menu',
  master: 'master'
};

// export function useGetMenuMaster() {
//   const { data, isLoading } = useSWR(endpoints.key + endpoints.master, () => initialState, {
//     revalidateIfStale: false,
//     revalidateOnFocus: false,
//     revalidateOnReconnect: false
//   });

//   const memoizedValue = useMemo(
//     () => ({
//       menuMaster: data,
//       menuMasterLoading: isLoading
//     }),
//     [data, isLoading]
//   );

//   return memoizedValue;
// }

// export function handlerDrawerOpen(isDashboardDrawerOpened) {
//   // to update local state based on key

//   mutate(
//     endpoints.key + endpoints.master,
//     (currentMenuMaster) => {
//       return { ...currentMenuMaster, isDashboardDrawerOpened };
//     },
//     false
//   );
// }

export function useGetMenuMaster() {
  const isMobile = window.innerWidth < 992;

  const { data, isLoading } = useSWR(
    endpoints.key + endpoints.master,
    () => ({
      ...initialState,
      isDashboardDrawerOpened: isMobile ? false : initialState.isDashboardDrawerOpened
    }),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );

  return useMemo(
    () => ({
      menuMaster: data,
      menuMasterLoading: isLoading
    }),
    [data, isLoading]
  );
}

export function handlerDrawerOpen(isDashboardDrawerOpened) {
  // to update local state based on key

  mutate(
    endpoints.key + endpoints.master,
    (currentMenuMaster) => {
      return { ...currentMenuMaster, isDashboardDrawerOpened };
    },
    false
  );
}
